import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { SESSION_VAR_KEY_MARKET, SESSION_VAR_KEY_CURRENCY } from '@ibe.config';
import { INDRACurrencyService } from './currency.indra.service';
@Pipe({
	name: 'indracurrency',
})
export class INDRACurrencyPipe implements PipeTransform {

	constructor(private currencyService: INDRACurrencyService) { }

	transform(
		value: any,
		code?: string,
		display:
			| 'code'
			| 'symbol'
			| 'symbol-narrow'
			| 'wide'
			| string
			| boolean = 'symbol',
		digitsInfo: string = '.2-2',
		locale: string = sessionStorage.getItem(SESSION_VAR_KEY_MARKET),
	): string | null {

		let formattedPrice = '';
		if (/\d/.test(value)) {
			if (code) {
				// if value is only number (ex: 100, 5) - need to pass code (M for miles, currency code for cash - EUR, USD etc..)
				const price = +value;
				if (code === 'M' || code === 'miles') {
					formattedPrice = this.currencyService.INDRA_formatMiles(price, locale) + ' ' + code;
				} else {
					formattedPrice = this.currencyService.INDRA_formatCash(price, locale) + ' ' + this.currencyService.INDRA_getCurrencySymbol(code).unit;
				}
			} else {
				// if value is string (ex: 100€, 5M, 100€ + 5M)
				const values: Array<any> = value.replace(/\s+/g, '').split('+');
				values.forEach((val: string) => {
					if (formattedPrice) formattedPrice += ' + ';
					let priceStr = '';
					let unit = '';
					val.split(/(\d+)/).forEach(char => {
						if (char) +char >= 0 || char === ',' || char === '.' ? priceStr = priceStr.concat(char) : unit = unit.concat(char);
					});

					const price = unit === 'M' ? +(priceStr.replace('.', '')) : +priceStr;
					if (unit === 'M') {
						formattedPrice += this.currencyService.INDRA_formatMiles(price, locale) + ' ' + unit;
					} else {
						formattedPrice += this.currencyService.INDRA_formatCash(price, locale) + ' ' + unit;
					}
				});
			}
		}

		return formattedPrice ? formattedPrice : value;
	}
}
